// extracted by mini-css-extract-plugin
export default {"wrapper":"iKno3it"};